export default __webpack_public_path__ + "static/media/video.d8673b86.svg";